<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/PMReport/PMOperationReport'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}

            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                v-show="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM', 
                    'COOL_SERVICE_PM',
                  ])
                "
              >
                <div class="form-group">
                  <label >ตัวแทนจำหน่าย:</label>
                  
                  <treeselect
                    v-model="reAgentCodes"
                    :multiple="true"
                    :options="reAgentCodesOptions"
                    v-on:open="LoadreAgentCodesOptions" 
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                    @input="updateValueAgentCodes"
                  />
                  <span
                    class="form-text"
                    style="color: #fd397a;"
                    v-show="AgentCodesMessagesStatus == true"
                    >{{ AgentCodesMessages }}</span
                  >
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
              v-show="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM', 
                    'COOL_SERVICE_PM',
                  ])
                "
              >
                <div class="form-group">
                  <label>ร้านค้า:</label> 
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reShopCodes'"
                    :name="'reShopCodes'"
                    :select2-options="pmrShopCodesOptions"
                    v-model="reShopCodes"
                    ref="reShopCodesSelect2"
                    multiple
                  ></select2>
                </div>
              </div> 

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reDepartments'"
                    :name="'reDepartments'"
                    :select2-options="reDepartmentsOptions"
                    multiple
                    v-model="reDepartments"
                  ></select2> -->
                  <treeselect
                    v-model="reDepartments"
                    :multiple="true"
                    :options="reDepartmentsOptions"
                    v-on:select="ClearAgentCodesOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทกิจกรรม:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reActivityType'"
                    :name="'reActivityType'"
                    :select2-options="reActivityTypeOptions"
                    v-model="reActivityType"
                    ref="reActivityTypeSelect2"
                  ></select2> 
                </div>
              </div>


            </div>

            <div class="row" > 
            <!-------ตัวแทนจำหน่ายย่อย---->
            <div  
            v-show="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',
                    'COOL_SERVICE_PM',
                  ])
                " 
                class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย:</label>
                  
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrSubAgentCodes'"
                    :name="'pmrSubAgentCodes'"
                    :select2-options="pmrSubAgentCodeOptions"
                    v-model="pmrSubAgentCodes"
                    ref="pmrSubAgentCodesSelect2"
                    multiple
                  ></select2>
 
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ร้านค้าตัวแทนจำหน่ายย่อย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrSubAgentShopCodes'"
                    :name="'pmrSubAgentShopCodes'"
                    :select2-options="pmrSubAgentShopCodesOptions"
                    v-model="pmrSubAgentShopCodes"
                    ref="pmrShopCodesSelect2"
                    multiple
                  ></select2> 
                </div>
              </div>
            <!-------สิ้นสุดตัวแทนจำหน่ายย่อย-->

            <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">เดือน:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reMonth'"
                    :name="'reMonth'"
                    :select2-options="reMonthOptions"
                    v-model="reMonth"
                    ref="reMonthSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">ปี :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reYear'"
                    :name="'reYear'"
                    :select2-options="reYearOptions"
                    v-model="reYear"
                    ref="reYear"
                  ></select2>
                </div>
              </div>


            
            </div>

            <div class="row">

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์ที่ล้าง:</label> 
                  <treeselect
                    v-model="rePMBrand"
                    :multiple="true"
                    :options="rePMBrandOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะร้านค้า:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reShopStatus'"
                    :name="'reShopStatus'"
                    :select2-options="reShopStatusOptions"
                    v-model="reShopStatus"
                    ref="reShopStatusSelect2"
                  ></select2>
                </div>
              </div> 

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะประเภทร้านค้า:</label>
                  <treeselect
                    v-model="shmShopGroupId"
                    :multiple="true"
                    :options="shmShopGroupIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทการล้างเครื่อง:</label>
                  <treeselect
                    v-model="shmShopPMType"
                    :multiple="true"
                    :options="shmShopPMTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> 

            </div>

            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ผู้ดำเนินการ:</label>
                  <treeselect
                    v-model="rePMCreatedUserId"
                    :multiple="true"
                    :load-options="LoadreAPMCreatedUserIdOptions"
                    :async="true"
                    v-on:open="reLoadreAPMCreatedUserIdOptions"
                    v-on:select="ClearAfterselect"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="true"
                    ref="rePMCreatedUserId"
                  />
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMCreatedUserId'"
                    :name="'rePMCreatedUserId'"
                    :select2-options="LoadreAPMCreatedUserIdOptions"
                    v-model="rePMCreatedUserId"
                    multiple
                    ref="rePMCreatedUserIdSelect2"
                  ></select2> -->
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะผู้ดำเนินการ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reUserStatus'"
                    :name="'reUserStatus'"
                    :select2-options="reUserStatusOptions"
                    v-model="reUserStatus"
                    ref="reUserStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset($event)"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportMasterShop"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form --> 
          <!--begin: Table -->
          
          <div class="row"> 
            <div class="col-lg-12 table-responsive">
              <hr/>
              <div class="row mb-2"> 
                <div class="col-xl-6 text-left">
                    <button
                      class="btn btn-warning"
                      @click="PrevMonthClick"
                      type="submit"
                    >
                      <span>
                        <i class="fas fa-arrow-left"></i><span>เดือนก่อนหน้า </span>
                      </span>
                    </button>
                  </div>
                  <div class="col-xl-6 text-right">
                    <button
                      class="btn btn-warning"
                      @click="NextMonthClick"
                      type="submit"
                    >
                      <span>
                        <span>เดือนถัดไป</span> <i class="fas fa-arrow-right"></i>
                      </span>
                    </button>
                  </div>
              </div>
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="SurveyTable"
                style="width:100%"
              >
                <thead>
                  <!-- <tr>
                    <th class="all text-right" colspan="53">
                      

                    </th>
                  </tr> -->
                  <tr>
                    <th class="all text-center">ประเภทตัวแทนจำหน่าย</th>
                    <th class="all text-center">รหัสตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย</th>
                    <th class="all text-center">ประเภทร้านค้า</th>
                    <th class="all text-center">เขตการขาย</th>
                    <th class="all text-center">รหัสร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center">สถานะประเภทร้านค้า</th>
                    <th class="all text-center">ประเภทการล้างเครื่อง</th>
                    <th class="all text-center">ที่อยู่</th>
                    <th class="all text-center">ตำบล</th>
                    <th class="all text-center">อำเภอ</th>
                    <th class="all text-center">จังหวัด</th>
                    <th class="all text-center">รหัสไปรษณีย์</th>
                    <th class="all text-center">วันที่ (เปิด/ปิด ร้านค้า)</th>
                    <th class="all text-center">เดือน</th>
                    <th class="all text-center">ปี</th>
                    <th class="all text-center">แบรนด์ที่จับคู่</th>
                    <th class="all text-center">แบรนด์ที่ล้าง</th>
                    <th class="all text-center">ผู้ดำเนินการ</th>
                    <th class="all text-center">จำนวน PM</th>
                    <th class="all text-center">D01</th>
                    <th class="all text-center">D02</th>
                    <th class="all text-center">D03</th>
                    <th class="all text-center">D04</th>
                    <th class="all text-center">D05</th>
                    <th class="all text-center">D06</th>
                    <th class="all text-center">D07</th>
                    <th class="all text-center">D08</th>
                    <th class="all text-center">D09</th>
                    <th class="all text-center">D10</th>
                    <th class="all text-center">D11</th>
                    <th class="all text-center">D12</th>
                    <th class="all text-center">D13</th>
                    <th class="all text-center">D14</th>
                    <th class="all text-center">D15</th>
                    <th class="all text-center">D16</th>
                    <th class="all text-center">D17</th>
                    <th class="all text-center">D18</th>
                    <th class="all text-center">D19</th>
                    <th class="all text-center">D20</th>
                    <th class="all text-center">D21</th>
                    <th class="all text-center">D22</th>
                    <th class="all text-center">D23</th>
                    <th class="all text-center">D24</th>
                    <th class="all text-center">D25</th>
                    <th class="all text-center">D26</th>
                    <th class="all text-center">D27</th>
                    <th class="all text-center">D28</th>
                    <th class="all text-center">D29</th>
                    <th class="all text-center">D30</th>
                    <th class="all text-center">D31</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;
    const d = new Date();
    var current_month =  d.getMonth()+1;
    var current_year = d.getFullYear();

    return {
      AgentCodesMessages: "กรุณาเลือกตัวแทนจำหน่าย",
      AgentCodesMessagesStatus: false,
      reAaIsInitial: true, 
      reDepartments: [],
      reAgentCodes: [],
      reShopTypeId: [],
      reType: null,
      reMonth: current_month,
      reYear: current_year,
      reShopStatus: '0',
      reProductBrandId: null,
      reUserIds: [],
      reUserIdsOptions: [],
      reUserStatus: null,
      brandHeaders: [],
      reDepartmentsOptions: [],
       
      reAgentCodesOptions: [],

      reShopCodes: [],
      reShopCodesOptions: [], 

      pmrSubAgentCodes : [],
      pmrSubAgentCodeOptions : [],
      pmrSubAgentShopCodes : [],
      pmrSubAgentShopCodesOptions : [],

      rePMBrand: [], 
      rePMBrandOptions: [],

      shmShopGroupId : [],
      shmShopGroupIdOptions : [],

      shmShopPMType: [],
      shmShopPMTypeOptions : [],

      rePMCreatedUserId : [],
       
      reActivityType : null,
      reActivityTypeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "0", text: "ไม่ทำ PM", data: null },
          { id: "1", text: "ทำ PM", data: null },
          
        ],
      },  
      LoadreAPMCreatedUserIdOptions({ action, searchQuery, callback }){
      if (action === ASYNC_SEARCH) {
        var self = this;
        axios
          .get("/Api/Report/AlertPM/UserOptions", {
            params: {
              page: 1,
              all: true,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              var result = [];
              data.forEach((element) => {
                result.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, result);
          })
          .catch(function(error) {});
      }
    },
      LoadrePMCreatedUserIdOptions: {
        placeholder: "ชื่อ-สกุล ผู้ดำเนินการ ",
        allowClear: true,
        ajax: {
          url: "/Api/PM/Select2PmUser",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.rePMAgentCode,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      LoadshmShopPMTypeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Select2MasterShopTypePM", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.shmShopPMTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
      }, 
      LoadShopGroupIdOptions: function(e) {
        var self = this;
        axios
          .get("/Api/ShopType/Select2SearchShopGroup", {
            params: {
              page: 1,
              all: true,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              data.forEach((element) => {
                self.shmShopGroupIdOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
          })
          .catch(function(error) {});
      }, 
      reMonthOptions: {
        placeholder: "ทั้งหมด",
        allowClear: false,
        data: [
          { id: "1", text: "January", data: null },
          { id: "2", text: "February", data: null },
          { id: "3", text: "March", data: null },
          { id: "4", text: "April", data: null },
          { id: "5", text: "May", data: null },
          { id: "6", text: "June", data: null },
          { id: "7", text: "July", data: null },
          { id: "8", text: "August", data: null },
          { id: "9", text: "September", data: null },
          { id: "10", text: "October", data: null },
          { id: "11", text: "November", data: null },
          { id: "12", text: "December", data: null },
        ],
      },
      reYearOptions: {
        placeholder: "กรุณาเลือก",
        data: [
          {
            id: new Date().getFullYear(),
            text: new Date().getFullYear(),
            data: null,
          },
          {
            id: new Date().getFullYear() - 1,
            text: new Date().getFullYear() - 1,
            data: null,
          },
          {
            id: new Date().getFullYear() - 2,
            text: new Date().getFullYear() - 2,
            data: null,
          },
          {
            id: new Date().getFullYear() - 3,
            text: new Date().getFullYear()- 3,
            data: null,
          },
          {
            id: new Date().getFullYear() - 4,
            text: new Date().getFullYear() - 4,
            data: null,
          },
        ],
      },
      reShopStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "0", text: "ร้านเปิด", data: null },
          { id: "1", text: "ร้านปิด", data: null },
        ],
      },
      reUserStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
      reProductBrandIdOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกแบรนด์สินค้า",
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reTypeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "PM", text: "PM", data: null },
          { id: "QI", text: "QC", data: null },
          { id: "MKT", text: "MKT", data: null },
          { id: "MT", text: "MT", data: null },
        ],
      }, 
      pmrSubAgentShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
         //pmrSubAgentCodes
        ajax: {
          url: "/Api/Shop/SubShopOptionAlertReport",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = { 
              agentCodes : self.reAgentCodes, 
              shopCodes  : self.pmrSubAgentCodes,
              search: params.term,
              page: params.page || 1,
              all: true,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      pmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {

            var isAllAgent = false ;
            if(self.reAgentCodes.indexOf("99999999") > -1){ 
                  isAllAgent = true;
                  self.reAllAgentCodes = [] ;
                  self.reAgentCodesOptions.forEach((element) => {
                      self.reAllAgentCodes.push(element.id);
                    }); 
                }
                else{
                  self.reAllAgentCodes = [];
                }  
 
              
            var query = {
              agentCodes: (isAllAgent) ?  self.reAllAgentCodes  : self.reAgentCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      pmrShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.reAgentCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this; 
      var d  = new Date() ;
      var current_month = d.getMonth()+1;
      var current_year = d.getFullYear();

      self.reDepartments = [] ;
      self.reAgentCodes = [] ;
      self.reShopTypeId = [] ;
      self.reMonth = current_month;
      self.reYear = current_year;
      self.reShopStatus = '0';
      self.reProductBrandId = null;
      self.reUserIds = [] ;
      self.reUserIdsOptions = [] ;
      self.reUserStatus = null ; 
      self.reShopCodes = [] ;
      self.pmrSubAgentCodes = [] ;
      self.pmrSubAgentShopCodes = [] ;
      self.rePMBrand = [] ; 
      self.shmShopGroupId = [] ;
      self.shmShopPMType = [] ;
      self.rePMCreatedUserId = [] ;
       

      $("#reDepartments")
        .val("")
        .trigger("change");

      $("#reAgentCodes")
        .val("")
        .trigger("change");

      $("#reMonth")
        .val(current_month)
        .trigger("change");

      $("#reYear")
        .val(current_year)
        .trigger("change");

      $("#reShopStatus")
        .val(self.reShopStatus)
        .trigger("change");

      $("#rePMBrand")
        .val("")
        .trigger("change");

      $("#shmShopPMType")
        .val("")
        .trigger("change");
      
      $("#reShopStatus")
      .val("")
      .trigger("change");

      $("#rePMCreatedUserId")
        .val("")
        .trigger("change");

      $("#reUserStatus")
        .val("")
        .trigger("change");

        $("#reActivityType")
        .val("")
        .trigger("change");

        $("#pmrSubAgentCodes")
        .val("")
        .trigger("change");

        $("#pmrSubAgentShopCodes")
        .val("")
        .trigger("change");

       this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function(e, innerText = null) {
      let self = this; 

       

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();

   
        var table = $("#SurveyTable").DataTable();
        table.draw();
       
    },
    exportMasterShop: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportPMCalendar",
        responseType: "arraybuffer",
        data: {
            Year: self.reYear,
            Month: self.reMonth, 
            AgentCode: self.reAgentCodes,
            ShopList: self.reShopCodes, 
            SaleArea: self.reDepartments,
            ActivityType : self.reActivityType,
            SubAgentCode : self.pmrSubAgentCodes,
            SubAgentShopList : self.pmrSubAgentShopCodes, 
            BrandList: self.rePMBrand,  
            ShopStatus: self.reShopStatus, 
            PMType: self.shmShopPMType,
            StatusTypeShop : self.shmShopGroupId,
            UserList: self.rePMCreatedUserId,
            UserStatus: self.reUserStatus, 
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            var fname = filename.split("RPT_")[1] ;   

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "รายงานปฏิทินบันทึกงาน PM_" + fname //+ filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    }, 
    reLoadreAPMCreatedUserIdOptions: function(){ 
        this.$refs.rePMCreatedUserId.trigger.searchQuery = null; 
      },
    ClearAfterselect: function() {
        $(`[class="vue-treeselect__input"]`).val("");
      },
    LoadreDepartmentsOptions: function(e) {
      var self = this; 
      axios
        .get("/Api/MasterSalesArea/FindOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reDepartmentsOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAgentCodesOptions: function(e) {
      var self = this;
      self.reAgentCodesOptions = [
        { id: "", label: "Loading...", isDisabled: true },
      ]; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
      axios
        .post("/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM", {
          province_id: [],
          department: self.reDepartments,
          agentCodes: [],
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            // if (self.reDepartments.length == 0) {
            //   self.reAgentCodesOptions = [{ id: "99999999", label: "ทั้งหมด" }];
            // } else {
            //   self.reAgentCodesOptions = [];
            // }
            self.reAgentCodesOptions = [];
            var data = response.data.results;
            data.forEach((element) => {
              self.reAgentCodesOptions.push({
                id: element.id,
                label: element.text,
                isDisabled: self.reAgentCodes[0] == "" ? true : false,
              });
            });
          }
        })
        .catch(function(error) {});
    }, 
    updateValueAgentCodes: function(e) {
      this.reShopCodes = [];
      this.reShopCodesOptions = [];
      this.LoadreShopCodesOptions("ASYNC_SEARCH", "", null);
    },
    ClearAgentCodesOptions: function(e) {
      //this.reAgentCodes = [];
    },
    FncreInActiveStatus: function(e) {
      // var options = [];
      $("#reShopStatus").html(null);
      if ($(`#reInActiveStatus`).is(":checked")) {
        $("#reShopStatus").select2({
          placeholder: "ทั้งหมด",
          allowClear: false,
          data: [{ id: true, text: "ร้านเปิด", data: null }],
        });
        this.reShopStatus = true;
      } else {
        $("#reShopStatus").select2({
          placeholder: "ทั้งหมด",
          allowClear: true,
          data: [
            { id: true, text: "ร้านเปิด", data: null },
            { id: false, text: "ร้านปิด", data: null },
          ],
        });
        this.reShopStatus = true;
      }
    },
    LoadrePMBrandOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/PM/ProductBrandOptions", {
        //.get("/Api/Report/PM/BrandOptions", {
          params: {
            page: 1,
            productTypeId: 6,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMBrandOptions.push({
                id: element.data,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    PrevMonthClick: function(e) {
      let self = this;
      var currentDate = moment(self.reYear+'-'+self.reMonth+'-01');
      var prevMonth = moment(currentDate).add(-1, 'M');

      var d  = new Date() ; 
      var begin_year = d.getFullYear()-4;  

      if(self.reMonth+"-"+self.reYear == "1-"+begin_year){
        Swal.fire(
              "สิ้นสุดปีเริ่มต้น",
              "ข้อมูลถึงสิ้นปีเริ่มต้นแล้ว",
              "warning"
            );
      }
      else{
        self.reYear = prevMonth.year();
        self.reMonth = prevMonth.month()+1;

        $("#reMonth")
          .val(prevMonth.month()+1)
          .trigger("change");

        $("#reYear")
          .val(prevMonth.year())
          .trigger("change"); 

          this.formSubmit(e, "");
      }
    },
    NextMonthClick: function(e) {
      let self = this; 

      var d  = new Date() ; 
      var current_year = d.getFullYear(); 

      if(self.reMonth+"-"+self.reYear == "12-"+current_year){
        Swal.fire(
              "สิ้นสุดปีปัจจุบัน",
              "ข้อมูลถึงสิ้นปีปัจจุบันแล้ว",
              "warning"
            );
      }
      else{
        var currentDate = moment(self.reYear+'-'+self.reMonth+'-01');
        var nextMonth = moment(currentDate).add(1, 'M');
        

        self.reYear = nextMonth.year();
        self.reMonth = nextMonth.month()+1; 

        $("#reMonth")
          .val(self.reMonth)
          .trigger("change");

        $("#reYear")
          .val(self.reYear)
          .trigger("change");

          this.formSubmit(e, "");
      }
    },
     
  },
  async mounted() {
    let self = this;

    self.LoadreDepartmentsOptions();
    self.LoadreAgentCodesOptions();
    self.LoadrePMBrandOptions(); 
    self.LoadShopGroupIdOptions();
    self.LoadshmShopPMTypeOptions(); 

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#SurveyTable");
    table.DataTable({
      autoWidth: true,
      scrollY: "100%",
      scrollX: true,
      responsive: true,
      processing: true,
      serverSide: true,
      searchDelay: 500,
      ajax: {
        url: "/Api/Report/PMCalendar",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        beforeSend: function(request) {
          request.setRequestHeader(
            "Authorization",
            "Bearer " + self.$root.user.access_token
          );
        },
        data: function(d) {
          let jsonSearch = {
            Year: self.reYear,
            Month: self.reMonth, 
            AgentCode: self.reAgentCodes,
            ShopList: self.reShopCodes, 
            SaleArea: self.reDepartments,
            ActivityType : self.reActivityType,
            SubAgentCode : self.pmrSubAgentCodes,
            SubAgentShopList : self.pmrSubAgentShopCodes, 
            BrandList: self.rePMBrand,  
            ShopStatus: self.reShopStatus, 
            PMType: self.shmShopPMType,
            StatusTypeShop : self.shmShopGroupId,
            UserList: self.rePMCreatedUserId,
            UserStatus: self.reUserStatus, 
            IsInitial: self.reAaIsInitial 
 
          };
          return JSON.stringify($.extend(d, jsonSearch));
        },
      },
      // DOM Layout settings
      dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

      lengthMenu: [30, 50, 100],

      pageLength: 30,

      language: {
        lengthMenu: "Display _MENU_",
      },
      // Order settings
      order: [[19, "desc"]],
      columns: [
        { data: "agentTypeName", className: "text-center" },
        {
          data: "agentCode",
          className: "text-center",
          render: function(data, type, full, meta) {
            return (full.shopTypeCode == "SHOP_SUB_AGENT") ? full.cusT_CODE : full.agentCode;
          },
        },
        {
          data: "agentName",
          className: "text-center",
          render: function(data, type, full, meta) {
            return (full.shopTypeCode == "SHOP_SUB_AGENT") ? full.shopName1 : full.agentName;
          },
        },
        { data: "shopTypeName", className: "text-center" }, 
        { data: "department", className: "text-center" },
        {
          data: "cusT_CODE",
          className: "text-center",
          render: function(data, type, full, meta) {
            return (full.shopTypeCode == "SHOP_SUB_AGENT") ? full.shoP_SUB_AGENT_CODE : full.cusT_CODE;
          },
        },
        {
          data: "shopName1",
          className: "text-center",
          render: function(data, type, full, meta) {
            return (full.shopTypeCode == "SHOP_SUB_AGENT") ? full.shoP_SUB_AGENT_SHOP_NAME : full.shopName1;
          },
        },
        {
          data: "shopName2",
          className: "text-center",
          render: function(data, type, full, meta) {
            return (full.shopTypeCode == "SHOP_SUB_AGENT") ? full.shoP_SUB_AGENT_SHOP_NAME2 : full.shopName2;
          },
        }, 
        { data: "shopGroupName", className: "text-center" }, 
        { data: "shopPMTypeName", className: "text-center" }, 
        { data: "address", className: "text-left" },
        { data: "tumboL_NAME", className: "text-left" },
        { data: "amphuR_NAME", className: "text-left" },
        { data: "provincE_NAME", className: "text-left" },
        { data: "zipCode", className: "text-center" }, 
        { data: "changeDateString", className: "text-center" },
        { data: "monthName", className: "text-center" }, 
        { data: "year", className: "text-center" },
        { data: "barcodeMappingBrands", className: "text-center" },
        { data: "pmBrands", className: "text-center" },
        { data: "fullName", className: "text-center" },
        { data: "totalPM", className: "text-center" },
        { data: "d01", className: "text-center" },
        { data: "d02", className: "text-center" },
        { data: "d03", className: "text-center" },
        { data: "d04", className: "text-center" },
        { data: "d05", className: "text-center" },
        { data: "d06", className: "text-center" },
        { data: "d07", className: "text-center" },
        { data: "d08", className: "text-center" },
        { data: "d09", className: "text-center" },
        { data: "d10", className: "text-center" },
        { data: "d11", className: "text-center" },
        { data: "d12", className: "text-center" },
        { data: "d13", className: "text-center" },
        { data: "d14", className: "text-center" },
        { data: "d15", className: "text-center" },
        { data: "d16", className: "text-center" },
        { data: "d17", className: "text-center" },
        { data: "d18", className: "text-center" },
        { data: "d19", className: "text-center" },
        { data: "d20", className: "text-center" },
        { data: "d21", className: "text-center" },
        { data: "d22", className: "text-center" },
        { data: "d23", className: "text-center" },
        { data: "d24", className: "text-center" },
        { data: "d25", className: "text-center" },
        { data: "d26", className: "text-center" },
        { data: "d27", className: "text-center" },
        { data: "d28", className: "text-center" },
        { data: "d29", className: "text-center" },
        { data: "d30", className: "text-center" },
        { data: "d31", className: "text-center" },
      ],
      columnDefs: [
        {
          targets: [7, 8, 9, 10] /* column index */,
          orderable: false /* true or false */,
        },
      ],
      drawCallback: function(settings) {
        self.reAaIsInitial = false; 
      },
    })
    .on("error.dt", function ( e, settings, techNote, message ) {
      DatatableWarning.alert(techNote);
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/PMOperationReport.vue